// extracted by mini-css-extract-plugin
export default {"rowContainer":"Plans_rowContainer__NZ0w3","rowItems":"Plans_rowItems__nxFnK","colForm":"Plans_colForm__2Cp41","col":"Plans_col__+e1Y4"};